/*
1. getBannerMessage('success', 'One (1) item added to your cart.'); // Success Message 
2. getBannerMessage('error', 'We’ve encountered an error. Please try again.'); // Error Message
3. getBannerMessage('warning', 'Please review your cart - some items have become unavailable.  Clear unavailable items');
4. getBannerMessage('info-black', 'Uh oh!  Toasting not available at this location');
5. getBannerMessage('info-gray', 'Heads up - there’s a new sauce available down below!');
6. getBannerMessage('info-green', 'Congrats, tokens earned on that order!');
7. getBannerMessage('info-darkgreen', 'Heads up - there’s a new sauce available down below!');
8. getBannerMessage('info-yellow', 'Buy 2 Footlongs, Get 1 Free', false, false, {text:'View Deals', href:'#'}); 
9. getBannerMessage('warning', 'for info icon notification',false,false,true,callback function);
Parameters : 
   autohide - default is false if true message disapear after 3 seconds
   closable - default is false if true close button is used to close message
   link - link should be object which contain text and href e.g. {text : 'View Deals', href: '#'}
*/

function getBannerMessage(
  type,
  message,
  autohide = false,
  closable = false,
  infoIcon = false,
  closeClickCallback,
  link,
  element = ".header-sticky",
  customClass = "",
  callback
) {
  let svg = "";
  let linkdata = "";
  let infoIconData = "";
  $("" + element + " .banner-notification").remove();
  if (link) {
    linkdata =
      '<a href="' + link.href + '" class="banner-link">' + link.text + "</a>";
  }
  if (type === "success") {
    svg = closable ? renderLinkIcon("M19.778 4.222 4.22 19.778M4.222 4.222l15.556 15.556") : renderLinkIcon("m6.562 14.264 3.248 3.145 8.78-10.348");
    svg.firstChild.setAttribute("stroke", "#fff");
  }
  if (type === "error" || closable) {
    svg = renderLinkIcon("M19.778 4.222 4.22 19.778M4.222 4.222l15.556 15.556");
    svg.firstChild.setAttribute("stroke", "#fff");
  }
  if (type === "info-gray") {
    if (orderViewModel.defaultGray) {
      analytics.removalBannerAnalytics(message);
    }
    var d =
      "M14.75 7.22498C14.75 5.43005 13.2949 3.97498 11.5 3.97498C9.70507 3.97498 8.25 5.43005 8.25 7.22498H6.08333H5.5C5.22386 7.22498 5 7.44883 5 7.72498V7.80831C5 8.08445 5.22386 8.30831 5.5 8.30831H6.08333V18.0583C6.08333 19.2549 7.05338 20.225 8.25 20.225H14.75C15.9466 20.225 16.9167 19.2549 16.9167 18.0583V8.30831H17.5C17.7761 8.30831 18 8.08445 18 7.80831V7.72498C18 7.44883 17.7761 7.22498 17.5 7.22498H16.9167H14.75ZM11.6617 5.06425C12.7828 5.14696 13.6667 6.08275 13.6667 7.22498H9.33333L9.33928 7.06327C9.42199 5.94218 10.3578 5.05831 11.5 5.05831L11.6617 5.06425ZM7.16667 8.30831H8.25H14.75H15.8333V18.0583L15.826 18.1846C15.7635 18.7234 15.3056 19.1416 14.75 19.1416H8.25L8.12366 19.1344C7.58488 19.0718 7.16667 18.6139 7.16667 18.0583V8.30831ZM9.29167 10.475C9.01552 10.475 8.79167 10.6988 8.79167 10.975V15.3916C8.79167 15.6678 9.01552 15.8916 9.29167 15.8916H9.375C9.65114 15.8916 9.875 15.6678 9.875 15.3916V10.975C9.875 10.6988 9.65114 10.475 9.375 10.475H9.29167ZM13.625 10.475C13.3489 10.475 13.125 10.6988 13.125 10.975V15.3916C13.125 15.6678 13.3489 15.8916 13.625 15.8916H13.7083C13.9845 15.8916 14.2083 15.6678 14.2083 15.3916V10.975C14.2083 10.6988 13.9845 10.475 13.7083 10.475H13.625ZM10.9583 10.975C10.9583 10.6988 11.1822 10.475 11.4583 10.475H11.5417C11.8178 10.475 12.0417 10.6988 12.0417 10.975V16.475C12.0417 16.7511 11.8178 16.975 11.5417 16.975H11.4583C11.1822 16.975 10.9583 16.7511 10.9583 16.475V10.975Z";
    svg = renderLinkIcon(d);
    svg.firstChild.setAttribute("fill", "#fff");
  }
  let text =
    '<div aria-live="polite" role="alert" class="banner-notification ' +
    type +
    " " +
    customClass +
    '">' +
    '<div class="container" style="padding-right:30px;"><span class="Neutral-messaging">' +
    message +
    " </span>" +
    linkdata +
    '<button class="closeButton">' + 
    (svg && svg.outerHTML ? svg.outerHTML : "") +
    "</button></div>" +
    "</div>";
  if (infoIcon) {
    infoIconData =
      '<div class="icon-container"><div class="info-icon">i</div></div>';
    text =
      '<div aria-live="polite" role="alert" class="banner-notification ' +
      type +
      " " +
      customClass +
      '">' +
      '<div class="notification-container" style="padding-right:0px"><div class= "col-10 notification">' +
      infoIconData +
      '<span class="warning-messaging">' +
      message +
      ' </span></div><div class="col-2 close-icon"><button class="button-close closeBanner" aria-label="close">&times;</button></div></div></div>';
  }
  $(element).append(text);
  const excludedPages = ["paymentmethods",'profile', 'order-management', 'bag', 'product details','category Page', 'menu'];
  const dtmPageName = $("#dtmPageName").val();
  const excludeFlag = excludedPages.some(pageName => dtmPageName.includes(pageName));
  if(!excludeFlag) {
    analytics.bannerNotificationAnalytics(message);
  }
  function calculateDynamicHeight() {
    const hasNavbarCMS = document.querySelector(".navbar.cms");
    const hasDefaultStoreHeaderOld = document.querySelector(".defaultStoreHeader");
    const hasDefaultHeaderCompNew = document.querySelector(".defaultHeader__comp");
    const hasStickyHeader = document.querySelector(".navbar.sticky-header");
    let height = 0;
    if (hasNavbarCMS) {
      height =
        (hasDefaultStoreHeaderOld ? hasDefaultStoreHeaderOld.offsetHeight : 0) +
        (hasNavbarCMS ? hasNavbarCMS.offsetHeight : 0);
    } else {
      height =
        (hasDefaultHeaderCompNew ? hasDefaultHeaderCompNew.offsetHeight : 0) +
        (hasStickyHeader ? hasStickyHeader.offsetHeight : 0);
    }
    return height;
  }
  
  if ((type === "success" && !closable) || type === "info-gray" || autohide) {
    $(".banner-notification").delay(BannerTimingConfiguration).slideUp("slow");
    const height = calculateDynamicHeight();
    $(".banner-notification").css('top', height + 'px');
  }
  
  if((type === 'error' && element === '.header-sticky') || type === 'warning' || (type === 'success' && closable)){
      var height =calculateDynamicHeight();
      $(".banner-notification").css('top', height + 'px');
  }
  
  $(".bannerIcon, .container .closeButton, .closeBanner").on("click", function () {
    if(!excludeFlag) {
      analytics.manualBannerDismissAnalytics();
    }
    $(".banner-notification").slideUp("slow");
    const height = calculateDynamicHeight();
    $("#switchbodymaincontent").css('margin-top', height + 'px');
    if (typeof closeClickCallback === "function") {
      closeClickCallback();
    }
    const url = new URL(window.location.href);
    if (url.searchParams.has('operation')) {
      const operationValue = url.searchParams.get('operation');
      if (operationValue === 'complete' || operationValue === 'abort') {
        url.searchParams.delete('operation');
        const newUrl = url.pathname + (url.search ? '?' + url.searchParams.toString() : '');
        window.history.replaceState({}, document.title, newUrl);
      }
    }
  });
  if (typeof callback === "function") {
    callback();
  }
  $(document).ready(function () {
    if (type === "error" || closable) {
      $(".closeButton").attr("aria-label", "close")
    }
  })
}
function renderLinkIcon(dPathValue) {
  const iconSvg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  const iconPath = document.createElementNS(
    "http://www.w3.org/2000/svg",
    "path"
  );
  iconSvg.setAttribute("fill", "none");
  iconSvg.setAttribute("viewBox", "0 0 24 24");
  iconSvg.setAttribute("width", "24");
  iconSvg.setAttribute("height", "24");
  iconSvg.classList.add("bannerIcon");
  iconPath.setAttribute("d", dPathValue);
  iconPath.setAttribute("stroke-linecap", "round");
  iconSvg.appendChild(iconPath);
  return iconSvg;
}
